export interface IDatiqError extends IDatiqErrorCriteria {
    hasError: boolean;
    status?: string;
    message?: string;
    data?: unknown;
}

export const emptyDatiqError: IDatiqError = {
    hasError: false,
};

export enum DatiqErrorCriteriaTypes {
    Required = 'required',
    MinLength = 'minlength',
    MaxLength = 'maxlength',
    Min = 'min',
    Max = 'max',
    Pattern = 'pattern',
    PercentMin = 'percentmin',
    PercentMax = 'percentmax',
    DateMin = 'datemin',
    DateMax = 'datemax',
    DateRange = 'daterange',
    DateInvalid = 'matDatepickerParse',
    DateMinDays = 'dateMinDays',
    DateMaxDays = 'dateMaxDays',
    GeoIndeterminate = 'geoIndeterminate',
    GeoPartial = 'geoPartial',
}

export interface IDatiqErrorCriteria {
    [DatiqErrorCriteriaTypes.MinLength]?: number; // Min Length of the string
    [DatiqErrorCriteriaTypes.MaxLength]?: number; // Max length of the string
    [DatiqErrorCriteriaTypes.Min]?: number; // Min number
    [DatiqErrorCriteriaTypes.Max]?: number; // Max number
    [DatiqErrorCriteriaTypes.Pattern]?: string; // A regex pattern of valid characters
    [DatiqErrorCriteriaTypes.Required]?: boolean; // Must have a value
    [DatiqErrorCriteriaTypes.PercentMin]?: number; // Min Percent for the text
    [DatiqErrorCriteriaTypes.PercentMax]?: number; // Min Percent for the text
    [DatiqErrorCriteriaTypes.DateMin]?: Date; //Min Date for the text
    [DatiqErrorCriteriaTypes.DateMax]?: Date; //Max Date for the text
    [DatiqErrorCriteriaTypes.DateInvalid]?: boolean; //A general catch-all invalid entry
    [DatiqErrorCriteriaTypes.DateMinDays]?: number;
    [DatiqErrorCriteriaTypes.DateMaxDays]?: number;
    [DatiqErrorCriteriaTypes.GeoIndeterminate]?: boolean;
    [DatiqErrorCriteriaTypes.GeoPartial]?: boolean;
}
